import React from 'react';
import Wrapper from './Wrapper';
import logo from '../../assets/images/logo.svg';

export default function Footer() {
    return (
        <footer className="py-6 md:pb-8">
            <Wrapper>
                <div className="footer-top pb-6">
                    <a href="https://www.airproducts.co.uk" className="inline-block transition transform hover:translate-x-5 sm:mb-0"><img src={logo} alt="The Air Products logo" /></a>
                </div>
                <div className="footer-bottom pt-2.5 text-sm border-t border-grey">
                    <p className="text-grey-dark"> 
                    <a className="mr-1 pr-1 border-r border-grey-dark hover:underline" href="https://www.airproducts.co.uk/legal-notice" target="_blank" rel="noreferrer">Legal Notice</a>
                    <a className="mr-1 pr-1 border-r border-grey-dark hover:underline" href="https://www.airproducts.co.uk/privacy-notice">Privacy Notice</a>
                    <span className="mr-1 pr-1 border-r border-grey-dark">Copyright &copy; {new Date().getFullYear()} Air Products and Chemicals, Inc.</span>
                    <a className="hover:underline" href="https://www.airproducts.co.uk" target="_blank" rel="noreferrer">www.airproducts.co.uk <span className="text-primary">→</span></a>
                    </p>
                </div>
            </Wrapper>
        </footer>
        
    );
}